import { NgModule } from '@angular/core';

import { Accordion, AccordionContent, AccordionHeader, AccordionPanel } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { Card } from 'primeng/card';
import { Checkbox } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DrawerModule } from 'primeng/drawer';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { Listbox } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { Message } from 'primeng/message';
import { Paginator } from 'primeng/paginator';
import { Panel } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { RadioButton } from 'primeng/radiobutton';
import { SelectButton } from 'primeng/selectbutton';
import { SelectModule } from 'primeng/select';
import { Skeleton } from 'primeng/skeleton';
import { Slider } from 'primeng/slider';
import { Stepper, StepList, Step, StepPanels, StepPanel } from 'primeng/stepper';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { Toast } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { Tooltip } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';

@NgModule({
  imports: [
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent,
    ButtonModule,
    Card,
    Checkbox,
    DialogModule,
    DrawerModule,
    FileUploadModule,
    InputMaskModule,
    Listbox,
    MenuModule,
    Message,
    Paginator,
    Panel,
    PanelMenuModule,
    RadioButton,
    SelectButton,
    SelectModule,
    Skeleton,
    Slider,
    Stepper,
    StepList,
    Step,
    StepPanels,
    StepPanel,
    TabList,
    Tab,
    TabPanel,
    TabPanels,
    Tabs,
    TagModule,
    TieredMenuModule,
    ToggleSwitch,
    Toast,
    ToolbarModule,
    Tooltip,
    TreeModule,
  ],
  exports: [
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent,
    ButtonModule,
    Card,
    Checkbox,
    DialogModule,
    DrawerModule,
    FileUploadModule,
    InputMaskModule,
    Listbox,
    MenuModule,
    Message,
    Paginator,
    Panel,
    PanelMenuModule,
    RadioButton,
    SelectButton,
    SelectModule,
    Skeleton,
    Slider,
    Stepper,
    StepList,
    Step,
    StepPanels,
    StepPanel,
    TabList,
    Tab,
    TabPanel,
    TabPanels,
    Tabs,
    TagModule,
    TieredMenuModule,
    ToggleSwitch,
    Toast,
    ToolbarModule,
    Tooltip,
    TreeModule,
  ],
})
export class PrimeNGModule {}
